import styles from './style.module.scss';
import { Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EditIcon } from 'icons';
import axios from 'axios';
import { Player } from 'video-react';
import ReactAudioPlayer from 'react-audio-player';
import useBoardDocs from '../useBoardDocs';
import { fileTypes } from '../../../../retailAcademy/subPages/academyArticles/useAcademyArticles';


const AssetView = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { singleItem, loading } = useBoardDocs(false);
  const title = singleItem?.file?.file_name;
  return (
    <div>
      <PageHeader title={title}>
        <Link to={pathname.replace('asset-view', 'edit')}>
          <Button icon={<EditIcon />} big iconMargin type={'secondary'}>
            {t('MODIFICA')}
          </Button>
        </Link>
      </PageHeader>
      <Spin spinning={loading}>
        <div className={styles.content}>
          {singleItem?.file_format === fileTypes.music && (
            <ReactAudioPlayer src={singleItem?.file_url} controls />
          )}
          {singleItem.file_format === fileTypes.video && (
            <Player playsInline src={singleItem?.file_url} />
          )}
        </div>
      </Spin>
    </div>
  );
};

export default AssetView;
